import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { KeysHelpHolder } from "./KeysHelpHolder";

const AnswerButton = styled.div`
  min-width: 127px;
  width: auto;
  height: 35px;
  border: 2px solid white;
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  border-radius: 5px;
  color: white;
  padding: 0 20px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;

  ${(props) =>
    props.second &&
    css`
      top: 42px;
      border-color: rgba(255, 255, 255, 0);
    `};

  ${(props) =>
    props.third &&
    css`
      top: 84px;
      border-color: rgba(255, 255, 255, 0);
    `};
`;

export function Answers({ ...props }) {
  const { t } = useTranslation();
  return (
    <KeysHelpHolder
      title={t("selectOrChangeYourAnswers")}
      subtitle={t("justTapTheAnswer")}
      {...props}
    >
      <svg
        width="170"
        height="134"
        viewBox="0 0 170 134"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M106.776 83.5561C106.776 83.5561 107.292 82.9112 108.066 82.6532C108.839 82.3952 109.484 82.3952 109.484 82.3952C109.484 82.3952 109.484 81.6212 109.742 80.7183C110.258 79.4283 111.161 77.4934 111.548 74.6556C111.806 72.5916 112.064 70.1408 112.193 67.5609C112.322 64.465 112.709 60.8532 112.064 57.6283C111.29 53.2425 109.871 49.8887 108.324 45.7609C107.163 42.665 105.615 38.7952 104.841 35.8283C103.164 29.8946 101.616 24.4769 101.874 20.994C102.132 18.5431 103.551 17.1242 104.97 16.7372C110.258 15.1893 112.064 21.51 115.031 27.1857C116.579 30.2816 119.03 33.3774 120.191 35.8283C121.61 38.6662 122.126 40.2141 122.126 40.2141C122.126 40.2141 125.222 36.7313 127.673 34.9254C128.963 34.0224 130.253 32.4745 131.155 32.0875C132.445 31.4425 135.928 31.4425 137.605 33.2485C140.701 36.7313 142.12 43.568 142.12 43.568C142.12 43.568 144.958 43.31 146.764 45.5029C148.699 47.8248 149.215 49.1147 151.021 53.7585C151.021 53.7585 153.858 52.0816 156.309 54.6615C158.373 56.7254 159.663 60.8532 161.211 65.239C162.243 68.3348 164.178 69.7538 164.178 74.5266C164.178 79.9443 164.694 86.265 165.081 92.3278C165.21 96.3266 164.952 100.196 165.597 103.55C166.371 107.291 165.468 105.227 169.467 112.838C170.112 113.999 170.37 116.966 168.822 119.288C162.243 128.704 136.96 141.216 128.318 128.317C126.254 125.221 125.093 121.738 123.158 119.674C119.804 116.321 115.031 116.321 111.032 112.58C103.809 106.001 96.1981 100.97 94.1342 96.9715C93.7472 96.1976 93.2312 93.2307 92.4572 90.0059C91.9413 87.813 90.6513 85.878 90.2643 83.9431C89.1034 78.7834 87.8135 77.3644 87.6845 74.9135C87.6845 72.9786 89.1034 69.7538 88.7164 66.9159C88.5874 65.755 87.8135 63.5621 87.5555 61.8851C87.1685 59.1763 87.9425 56.4674 90.2643 56.0804C92.0703 55.8224 93.7472 56.3384 95.9401 58.2733C98.52 60.7242 100.842 64.336 101.874 67.0449C102.906 69.6248 102.132 72.0757 102.132 72.0757C102.132 72.0757 102.906 72.7206 103.422 74.5266C103.68 75.1715 103.938 76.5905 104.196 77.2354C104.841 78.9124 105.357 80.2023 105.615 81.1053C105.873 81.8792 105.615 82.3952 105.615 82.3952L106.776 83.5561Z"
            fill="white"
          />
          <path
            d="M118.643 21.252C118.643 28.0887 113.096 33.6355 106.259 33.6355C99.4227 33.6355 93.876 28.0887 93.876 21.252C93.876 14.4153 99.4227 8.86859 106.259 8.86859C113.096 8.86859 118.643 14.4153 118.643 21.252ZM106.259 11.4485C100.842 11.4485 96.3269 15.8343 96.3269 21.381C96.3269 26.7988 100.713 31.3136 106.259 31.3136C111.677 31.3136 116.192 26.9278 116.192 21.381C116.063 15.8343 111.677 11.4485 106.259 11.4485Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M127.802 54.6615C127.931 54.9195 129.479 54.2745 129.608 52.4686C129.737 49.8887 129.092 44.342 129.479 42.2781C129.995 39.5692 131.156 36.0863 130.382 35.5704C129.737 37.2473 127.544 38.0213 126.512 38.0213C124.061 38.0213 122.126 39.9562 122.126 39.9562C122.126 39.9562 122.513 40.8591 123.287 43.31C123.932 45.8899 127.286 53.5005 127.802 54.6615Z"
            fill="url(#paint0_linear)"
          />
          <path
            opacity="0.5"
            d="M145.474 59.8212C145.474 59.8212 144.442 58.5313 143.797 55.4354C143.152 52.2106 142.12 43.31 142.12 43.31C142.12 43.31 142.894 44.4709 143.539 46.9218C144.055 48.9857 143.539 48.5988 144.184 55.0485C144.313 56.0804 145.345 58.1443 145.474 59.8212Z"
            fill="url(#paint1_linear)"
          />
          <path
            opacity="0.5"
            d="M154.503 61.3692C154.503 61.3692 153.6 60.8532 153.084 59.3053C152.439 57.8864 151.666 53.7585 151.666 53.7585C151.666 53.7585 152.439 54.2745 152.955 55.4355C153.471 56.3384 152.955 56.2094 153.471 59.1763C153.471 59.6923 154.374 60.7242 154.503 61.3692Z"
            fill="url(#paint2_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="129.499"
            y1="38.3241"
            x2="123.562"
            y2="51.4987"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="146.344"
            y1="50.5264"
            x2="141.695"
            y2="52.3654"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="153.996"
            y1="57.2686"
            x2="152.239"
            y2="57.9638"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <clipPath id="clip0">
            <rect
              width="82.5562"
              height="128.994"
              fill="white"
              transform="translate(87.4263 4.86981)"
            />
          </clipPath>
        </defs>
      </svg>
      <AnswerButton>{t("Answer")}</AnswerButton>
      <AnswerButton second>{t("Answer")}</AnswerButton>
      <AnswerButton third>{t("Answer")}</AnswerButton>
    </KeysHelpHolder>
  );
}
